import script from "./process_performance_registration.vue?vue&type=script&setup=true&lang=js"
export * from "./process_performance_registration.vue?vue&type=script&setup=true&lang=js"

import "./process_performance_registration.vue?vue&type=style&index=0&id=79ccc164&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ccc164"]])

export default __exports__